var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filtersQuickSorted.length > 0
    ? _c("div", { staticClass: "filters-quick" }, [
        _c("div", { staticClass: "filters-quick__title" }, [
          _vm._v("Szybkie filtry")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filters-quick__wrapper" }, [
          _c(
            "ul",
            { staticClass: "filters-quick__list" },
            _vm._l(_vm.filtersQuickSorted, function(quickFilter) {
              return _c("li", { key: "quick-" + quickFilter.label }, [
                _c(
                  "button",
                  {
                    staticClass: "filters-quick__button btn--small",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.dispatchFilters({
                          filters: quickFilter.value
                        })
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(quickFilter.label) +
                        "\n                "
                    )
                  ]
                )
              ])
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }